import * as React from 'react';
export const pixSvg = React.forwardRef(function pixSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M10.108 10.158c.863 0 1.675.336 2.285.946l3.312 3.313c.238.238.628.24.867 0l3.3-3.3a3.212 3.212 0 0 1 2.285-.947h.397l-4.19-4.191a3.342 3.342 0 0 0-4.727 0l-4.18 4.179h.65ZM22.157 21.83a3.212 3.212 0 0 1-2.285-.946l-3.3-3.3a.627.627 0 0 0-.867 0l-3.312 3.312c-.61.61-1.422.946-2.285.946h-.65l4.179 4.18a3.342 3.342 0 0 0 4.726 0l4.192-4.192h-.398Z',
      fillRule: 'evenodd',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'm23.488 11.104 2.533 2.533a3.342 3.342 0 0 1 0 4.726l-2.533 2.533a.483.483 0 0 0-.18-.036h-1.151a2.276 2.276 0 0 1-1.599-.663l-3.3-3.3c-.598-.598-1.641-.598-2.24 0l-3.311 3.312a2.276 2.276 0 0 1-1.6.663H8.693a.483.483 0 0 0-.17.034L5.98 18.363a3.342 3.342 0 0 1 0-4.726l2.543-2.543c.053.02.11.034.17.034h1.416c.595 0 1.178.242 1.599.663l3.312 3.312a1.58 1.58 0 0 0 1.12.463 1.58 1.58 0 0 0 1.12-.464l3.3-3.3a2.276 2.276 0 0 1 1.598-.662h1.151a.483.483 0 0 0 .18-.036Z',
      fillRule: 'evenodd',
    }),
  );
});
pixSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var pix = {
  category: 'paymentmethod',
  colorable: true,
  name: 'pix',
  svg: pixSvg,
};
